module.exports = __webpack_public_path__ + "3.3-video.html";